import React from 'react'

function SvgEditIcons() {
  return (
    <>
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.99998 15.6667H16.5M1.5 15.6667H2.89545C3.3031 15.6667 3.50693 15.6667 3.69874 15.6206C3.8688 15.5798 4.03138 15.5125 4.1805 15.4211C4.34869 15.318 4.49282 15.1739 4.78107 14.8856L15.25 4.41669C15.9404 3.72634 15.9404 2.60705 15.25 1.91669C14.5597 1.22634 13.4404 1.22634 12.75 1.91669L2.28105 12.3856C1.9928 12.6739 1.84867 12.818 1.7456 12.9862C1.65422 13.1353 1.58688 13.2979 1.54605 13.468C1.5 13.6598 1.5 13.8636 1.5 14.2713V15.6667Z"
          stroke="#667085"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export default SvgEditIcons
